import { render } from "./ProjectNotificationManagementSettings.vue?vue&type=template&id=751effae"
import script from "./ProjectNotificationManagementSettings.vue?vue&type=script&lang=js"
export * from "./ProjectNotificationManagementSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__